import { render } from "./NftLineSvg.vue?vue&type=template&id=aec57dcc&ts=true"
import script from "./NftLineSvg.vue?vue&type=script&lang=ts"
export * from "./NftLineSvg.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__